// api/training.js
// Live training seat requests, posted from the public /training page.
//
// This deliberately does NOT go through apiClient: request() in api/client.js
// treats any 401 as an expired session and sends the browser to /login, which
// would throw a visitor off a public enquiry form mid submit. Same BASE_URL
// convention, no Authorization header, no redirect on any status.

const BASE_URL = process.env.REACT_APP_API_URL;

// Shown when the response carries nothing readable. A bare status code tells a
// visitor nothing they can act on, so this gives them a way through instead.
const GENERIC_ERROR =
  "Something went wrong on our end. Please try again, or message us on LinkedIn and we will get you a seat.";

export const trainingApi = {
  requestSeat: async (data) => {
    const res = await fetch(`${BASE_URL}/api/training-lead`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
      // A message in the body is one of the backend's readable validation
      // messages, so it is passed straight through.
      const body = await res.json().catch(() => ({}));
      throw new Error(body.message || GENERIC_ERROR);
    }

    const text = await res.text();
    return text ? JSON.parse(text) : null;
  },
};

export default trainingApi;
